import controller from './celect-option.controller';

const CelectOptionComponent = {
  controller,
  // TODO resolve how to use require within app separated with components and modules
  // require: {
  //   celect: '^Celect'
  // }
};

export default CelectOptionComponent;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/celect/celect-option.component.js